import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import GoogleForm from './pages/GoogleForm';
import ThankYou from './pages/ThankYou';
import SummaryPage from './pages/SummaryPage';

function App() {
  return (
    <Router>

      <Routes>
        <Route path="/" element={<GoogleForm />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/sommario" element={<SummaryPage />} />
      </Routes>

      <Footer />

    </Router>
  );
}

export default App;
